import React from 'react'
import { ImageSourcePropType } from 'react-native'

export type CrossPlatformImageProps = {
  source: string | ImageSourcePropType
  source2x?: string
  source3x?: string
  alt?: string
}

const CrossPlatformImage = (
  props: CrossPlatformImageProps
): React.ReactElement => {
  const { source, source2x, source3x, alt = '' } = props
  const srcSet = [
    `${source} 1x`,
    ...(source2x ? `, ${source2x} 2x` : []),
    ...(source3x ? `, ${source3x} 3x` : []),
  ].join('')

  return <img src={source as string} srcSet={srcSet} alt={alt} />
}

export default CrossPlatformImage
